import { FC, useMemo, useState } from 'react'
import { ResourceEventType, ResourceHistoryType } from '../../../model/ResourceHistory'
import { List, Switch } from '../../shared'
import { ResourceHistoryPanelProps } from './ResourceHistoryPanel.model'
import { ResourceHistoryPanelItem } from './ResourceHistoryPanelItem'
import styles from './ResourceHistoryPanel.module.scss'
import { useGetInfiniteResourceHistory } from '../../../hooks/queries/resourceHistory'
import { BottomPanel } from '../../shared/bottomPanel/BottomPanel'

const getPanelTitle = (type: ResourceHistoryType) => {
  switch (type) {
    case 'Patient':
      return 'Historique informations patient'
    default:
      return 'Historique'
  }
}

export const ResourceHistoryPanel: FC<ResourceHistoryPanelProps> = ({
  entityId,
  entityType,
  isUnmounting,
  onClose,
}) => {
  const [insAccessFilter, setInsAccessFilter] = useState(true)

  const excludeEventTypeFilter: Array<ResourceEventType> = useMemo(() => {
    const excludeEventType: Array<ResourceEventType> = []
    if (!insAccessFilter) {
      excludeEventType.push('ins_access')
    }

    return excludeEventType
  }, [insAccessFilter])

  const {
    historyList,
    paginationState,
    query: { isLoading, fetchNextPage },
  } = useGetInfiniteResourceHistory({
    entity: {
      id: entityId,
      type: entityType,
      excludeEventType: excludeEventTypeFilter.join(','),
    },
  })

  return (
    <BottomPanel
      testId="patient_history"
      title={getPanelTitle(entityType)}
      onRequestClose={onClose}
      isUnmounting={isUnmounting}
    >
      <div className={styles['container']}>
        <div className={styles.filtersArea}>
          <Switch
            name="Accès INS"
            checked={insAccessFilter}
            onChange={() => setInsAccessFilter(!insAccessFilter)}
            testId="display-ins-acces-history"
          />
        </div>

        <List
          testId="patient_history"
          noRef
          fullPageMode={false}
          items={historyList}
          loading={isLoading}
          itemCount={paginationState?.itemCount}
          pageCount={paginationState?.pageCount ?? 0}
          onUpdateList={() => fetchNextPage()}
          newDesignList={true}
          renderItem={(item) => <ResourceHistoryPanelItem historyDetail={item} type={entityType} />}
        />
      </div>
    </BottomPanel>
  )
}
